import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../Navbar/Navbar';
// import FluidBackground from '../../components/FluidBackground/FluidBackground';
import './AboutUs.css';
import ParticleBackground from '../../components/ParticleBackground/ParticleBackground';
import main2 from '../../asset/aboutus/main2.jpg';
import Nabeel from '../../asset/team/Nabeel.jpg';
import Zaki from '../../asset/team/Zaki.jpg';
import Meghana from '../../asset/team/Meghana.jpg';
import team from '../../asset/aboutus/team.jpg';
const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-us-page">
      <ParticleBackground />
      
      <div className="about-container">
        <Navbar />
        <div className="content-wrapper">
        <motion.div 
          className="about-header"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h1>About Us</h1>
          <div className="header-underline"></div>
        </motion.div>
        
        <div className="about-content">
          <motion.div 
            className="about-section"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
          >
            <div className="about-image">
              <img src={team} alt="Our Team" />
            </div>
            <div className="about-text">
              <h2>CB Team</h2>
              <p>
                At CodeBrew, we blend creativity with technology to craft immersive, interactive, and unforgettable experiences. 
                From smart activations to large-scale digital installations, we turn ambitious ideas into intuitive, real-world tech. 
                Whether it's a pop-up, pavilion, or exhibition stand—we're the tech guy next door who just gets it.
              </p>
              <p>
                We simplify the complex. We innovate with purpose. And most importantly, we make sure your brand doesn't just show up—it stands out.
              </p>
            </div>
          </motion.div>
          
          <motion.div 
            className="about-section reverse"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.4 }}
          >
            <div className="about-image">
              <img src={main2} alt="Our Mission" />
            </div>
            <div className="about-text">
              <h2>Mission</h2>
              <p>
                To make technology human, experiential, and approachable by building interactive solutions that emotionally connect brands and audiences.
              </p>
              <h2>Vision</h2>
              <p>
                To be the region's most trusted creative tech studio, redefining how people engage with spaces, stories, and experiences—one activation at a time.
              </p>
            </div>
          </motion.div>
          
          <motion.div 
            className="about-values"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.6 }}
          >
            <h2>Our Values</h2>
            <div className="values-grid">
              <div className="value-card">
                <div className="value-icon">🎯</div>
                <h3>Simplicity</h3>
                <p>At Codebrew, we believe in simple solutions. We make complex technologies and processes easy to understand and use, focusing on clarity and user-friendly design.</p>
              </div>
              <div className="value-card">
                <div className="value-icon">🚀</div>
                <h3>Ambition</h3>
                <p>At Codebrew, we set big goals and work hard to reach them. We believe in always getting better and encourage our community to aim for excellence in every project they take on.</p>
              </div>
              <div className="value-card">
                <div className="value-icon">✨</div>
                <h3>Innovation</h3>
                <p>At Codebrew, innovation is key. We always look for new and creative ways to solve problems and explore what's possible in tech. We encourage experimentation and forward-thinking to drive progress.</p>
              </div>
              <div className="value-card">
                <div className="value-icon">🤝</div>
                <h3>Collaboration</h3>
                <p>At Codebrew, we value teamwork because great ideas often come from working together and sharing different viewpoints. We encourage open communication, sharing knowledge, and supporting each other to reach our goals.</p>
              </div>
            </div>
          </motion.div>
          
          <motion.div 
            className="about-team"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.8 }}
          >
            <h2>Meet Our Team</h2>
            <div className="team-grid">
              <div className="team-member">
                <div className="member-image">
                  <img src={Nabeel} alt="Nabeel Ahamed" />
                </div>
                <h3>Nabeel Ahamed</h3>
                <p>General Manager</p>
              </div>
              <div className="team-member">
                <div className="member-image">
                  <img src={Meghana} alt="Meghana Dedia" />
                </div>
                <h3>Meghana Dedia</h3>
                <p>Account Manager</p>
              </div>
              <div className="team-member">
                <div className="member-image">
                  <img src={Zaki} alt="Mohammed Zaki" />
                </div>
                <h3>Mohammed Zaki</h3>
                <p>Project Engineer</p>
              </div>
             
            </div>
          </motion.div>
          </div>
        </div>
      </div>
      
      <style>
        {`
          /* Ensure navbar is always on top and clickable with all its elements */
          .navbar {
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            width: 100% !important;
            z-index: 9999 !important;
            pointer-events: auto !important;
          }
          
          /* Fix navbar pseudo-elements z-index and pointer-events */
          .navbar::before,
          .navbar::after {
            z-index: -1 !important;
            pointer-events: none !important;
          }
          
          /* Ensure navbar container and all child elements are clickable */
          .navbar-container,
          .navbar-logo,
          .navbar-center-menu,
          .navbar-burger,
          .navbar-logo a,
          .navbar-center-menu a,
          .hamburger {
            pointer-events: auto !important;
            z-index: inherit !important;
          }
          
          /* Fix blur background specifically */
          .navbar-blur-background {
            z-index: -1 !important;
            pointer-events: none !important;
          }

          /* Ensure particles background covers full screen on all devices */
          .particle-background-container {
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            width: 100vw !important;
            height: 100vh !important;
            min-height: 100vh !important;
            min-height: 100dvh !important; /* Better mobile support */
            min-height: -webkit-fill-available !important; /* Safari/Mac fix */
            z-index: 0 !important;
            pointer-events: none !important;
          }
          
          /* Mobile-specific fixes for particle background */
          @media screen and (max-width: 768px) {
            .about-us-page {
              min-height: 100vh;
              min-height: 100dvh; /* Dynamic viewport height for mobile */
              min-height: -webkit-fill-available; /* Safari fallback */
            }
            
            .navbar {
              position: fixed !important;
              top: 0 !important;
              left: 0 !important;
              width: 100% !important;
              z-index: 9999 !important;
              pointer-events: auto !important;
            }
            
            .navbar::before,
            .navbar::after {
              z-index: -1 !important;
              pointer-events: none !important;
            }
            
            .particle-background-container {
              position: fixed !important;
              top: 0 !important;
              left: 0 !important;
              width: 100vw !important;
              height: 100vh !important;
              min-height: 100vh !important;
              min-height: 100dvh !important;
              min-height: -webkit-fill-available !important;
              max-height: none !important;
              z-index: 0 !important;
              pointer-events: none !important;
            }
            
            /* Ensure tsparticles canvas covers full screen */
            #tsparticles {
              position: fixed !important;
              top: 0 !important;
              left: 0 !important;
              width: 100vw !important;
              height: 100vh !important;
              min-height: 100vh !important;
              min-height: 100dvh !important;
              min-height: -webkit-fill-available !important;
              z-index: 0 !important;
              pointer-events: none !important;
            }
          }
          
          /* Mac/Safari specific fixes for full viewport coverage */
          @media screen and (-webkit-min-device-pixel-ratio: 1) {
            .navbar {
              position: fixed !important;
              top: 0 !important;
              left: 0 !important;
              width: 100% !important;
              z-index: 9999 !important;
              pointer-events: auto !important;
            }
            
            .navbar::before,
            .navbar::after {
              z-index: -1 !important;
              pointer-events: none !important;
            }
            
            .particle-background-container {
              height: 100vh !important;
              min-height: 100vh !important;
              min-height: -webkit-fill-available !important;
              z-index: 0 !important;
              pointer-events: none !important;
            }
            
            #tsparticles {
              height: 100vh !important;
              min-height: 100vh !important;
              min-height: -webkit-fill-available !important;
              z-index: 0 !important;
              pointer-events: none !important;
            }
          }
          
          /* Additional Safari-specific fix */
          @supports (-webkit-appearance: none) and (not (contain: paint)) {
            .navbar {
              position: fixed !important;
              top: 0 !important;
              left: 0 !important;
              width: 100% !important;
              z-index: 9999 !important;
              pointer-events: auto !important;
            }
            
            .navbar::before,
            .navbar::after {
              z-index: -1 !important;
              pointer-events: none !important;
            }
            
            .particle-background-container,
            #tsparticles {
              height: calc(100vh + 1px) !important;
              min-height: calc(100vh + 1px) !important;
              z-index: 0 !important;
              pointer-events: none !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default AboutUs; 